<script lang="ts" setup>
import { computed, type PropType } from 'vue';

import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';
import { toastManagerInstance, OrderCancelFailedToast } from '@exchange/libs/toasts/src';

type CloseButtonVariant = 'desktop' | 'mobile';

const props = defineProps({
  cancelOrder: { type: Function as PropType<(id: string) => Promise<void>>, required: true },
  marketInMaintenance: { type: Boolean, required: true },
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  variant: { type: String as PropType<CloseButtonVariant>, default: 'desktop' },
});

const showOrderCloseButton = computed(() => props.order.isCancelable && !props.marketInMaintenance);

const closeOrder = () =>
  props.cancelOrder(props.order.id).catch((error) =>
    toastManagerInstance.addToast({
      content: OrderCancelFailedToast,
      props: {
        errorCode: error.data ? error.data.error : undefined,
      },
    }),
  );

defineExpose({
  showOrderCloseButton,
  closeOrder,
});
</script>

<template>
  <button
    v-if="showOrderCloseButton"
    class="order-close-button"
    name="close-order-button"
    :class="[`order-close-button--${variant}`]"
    testid="close-order-button"
    @click="closeOrder"
  >
    <ot-icon name="close-square" />
  </button>
</template>

<style lang="scss">
.order-close-button {
  display: flex;
  min-width: auto;
  height: auto;
  padding: 0;
  border-radius: 2px;
  color: rgb(var(--v-theme-text-primary));

  .svg-icon--close-square {
    .svg-icon {
      &__content {
        fill: rgb(var(--v-theme-text-secondary));
      }

      &__border {
        fill: rgb(var(--v-theme-elevation-2));
      }
    }
  }

  &:hover {
    .svg-icon--close-square .svg-icon__bg {
      fill: rgb(var(--v-theme-elevation-2));
      transition: 0.2s;
    }
  }
}
</style>
